"use client";
import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { field, textarea, label, counter } from './styles.js';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage.web.js';
import { ContentText } from '../ContentText/ContentText.web.js';
import { useFocused } from '../utils/hooks/useFocused.web.js';
import { useSmartControlledEventHandler } from '../utils/hooks/useSmartControlledEventHandler.web.js';
import { ThemeProvider } from 'styled-components';
import { Box } from '../Box/Box.web.js';
import { useTheme } from '../utils/theming/useTheme.js';

var _excluded = ["value", "disabled", "id", "name", "maxLength", "onChange", "label", "readOnly", "required", "error", "errorMessage", "textareaProps", "onBlur", "onFocus", "size", "variant", "color", "inputMode"];
var TEXTAREA_DEFAULT_MAX_LENGTH = 4096;
var Textarea = function Textarea(_ref) {
  var valueProp = _ref.value,
    disabled = _ref.disabled,
    id = _ref.id,
    name = _ref.name,
    maxLength = _ref.maxLength,
    onChange = _ref.onChange,
    label$1 = _ref.label,
    readOnly = _ref.readOnly,
    required = _ref.required,
    error = _ref.error,
    errorMessage = _ref.errorMessage,
    textareaProps = _ref.textareaProps,
    onBlurProp = _ref.onBlur,
    onFocusProp = _ref.onFocus,
    sizeProp = _ref.size,
    variantProp = _ref.variant,
    color = _ref.color,
    inputMode = _ref.inputMode,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSmartControlledEv = useSmartControlledEventHandler('', valueProp, onChange),
    _useSmartControlledEv2 = _slicedToArray(_useSmartControlledEv, 2),
    value = _useSmartControlledEv2[0],
    handleChange = _useSmartControlledEv2[1];
  var _useFocused = useFocused(false, onFocusProp, onBlurProp),
    focused = _useFocused.focused,
    onBlur = _useFocused.onBlur,
    onFocus = _useFocused.onFocus;
  var theme = useTheme();
  var variant = variantProp || theme.variant;
  var size = variant === 'condensed' ? 's' : sizeProp !== null && sizeProp !== undefined ? sizeProp : theme.preferredComponentSize;
  var inputTheme = theme.inputField.web;
  var getMaxlengthAttributeValue = function getMaxlengthAttributeValue() {
    if (!maxLength) {
      return TEXTAREA_DEFAULT_MAX_LENGTH;
    }
    return isFinite(maxLength) ? maxLength : undefined;
  };
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(field, _extends({
    "data-testid": "elemental-Textarea-".concat(id || name),
    $disabled: disabled,
    $error: error,
    $errorColor: inputTheme.error
  }, props), /*#__PURE__*/React.createElement(textarea, _extends({
    "data-testid": "elemental-Textarea-".concat(id || name, "-textarea"),
    disabled: disabled || readOnly,
    $disabledStyle: disabled,
    $empty: !value || !value.length,
    id: id || name,
    name: name,
    onChange: handleChange,
    readOnly: readOnly,
    rows: 5,
    value: value,
    onBlur: onBlur,
    onFocus: onFocus,
    $color: color ? color : inputTheme.color,
    "aria-labelledby": "".concat(id || name, "__label"),
    "aria-required": required,
    "aria-invalid": error,
    "aria-describedby": error ? "elemental-Textarea-".concat(id || name, "__error") : undefined,
    inputMode: inputMode,
    $size: size,
    maxLength: getMaxlengthAttributeValue()
  }, textareaProps)), /*#__PURE__*/React.createElement(label, {
    htmlFor: id || name,
    $size: size,
    id: "".concat(id || name, "__label")
  }, required ? "".concat(label$1, " *") : label$1), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/React.createElement(ErrorMessage, {
    flex: 1,
    active: Boolean(error && !focused),
    id: "elemental-Textarea-".concat(id || name, "__error")
  }, /*#__PURE__*/React.createElement(ContentText, null, errorMessage || 'Please check input')), maxLength && isFinite(maxLength) && /*#__PURE__*/React.createElement(counter, {
    "data-testid": "elemental-Textarea-".concat(id || name, "__counter"),
    $error: Boolean(error && !focused),
    $over: value ? value.length > maxLength : false,
    theme: theme
  }, value ? value.length : 0, "/", maxLength))));
};

export { Textarea };
